module.exports = __webpack_public_path__ + "img/fangdajing.d73365b5.png";